"use strict";
/**
 * The hockey pad's event vocabulary (docs/nhl-model/PLAN.md §3.5, §4.5).
 * Shared by the pad and the server reducer so the two can never disagree on
 * a kind. Unlike the football tap pad these are STATE-CHANGING events: the
 * tracker replays them into the game state that the model prices.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNDOABLE_HOCKEY_KINDS = exports.VALUED_HOCKEY_KINDS = exports.SIDED_HOCKEY_KINDS = exports.isHockeyEventKind = exports.HOCKEY_EVENT_KINDS = void 0;
exports.HOCKEY_EVENT_KINDS = [
    // Game frame
    "game_type", // value: 2 regular season, 3 playoff (the NHL API's gameType)
    "period_start", // faceoff of the next period: period += 1, clock full and running
    "period_end", // horn: clock 0 and stopped; intermission
    "final", // the game is over (the last period's horn, or the shootout's decision)
    // Clock
    "clock_start",
    "clock_stop",
    "clock_set", // value: seconds remaining in the CURRENT period (period itself via period_start/period_end)
    "clock_nudge", // value: ±seconds added to the remaining time
    // Goals
    "goal", // side: the scoring team
    "goal_pending", // side: scored but under review / challenge
    "goal_confirmed",
    "goal_overturned",
    // Penalties (side: the penalised team)
    "penalty_minor",
    "penalty_double_minor",
    "penalty_major",
    "penalty_misconduct", // no manpower change; logged
    "penalty_coincidental", // one minor each, 4v4 for 2:00
    "penalty_expired", // side: ends that side's earliest-ending serving penalty now (correction)
    "penalty_shot", // side: the SHOOTING team; resolved by goal or penalty_shot_miss
    "penalty_shot_miss",
    "delayed_penalty", // side: the team about to be penalised
    "delayed_penalty_off", // waved off / play stopped without a penalty
    // Goalies
    "goalie_pulled",
    "goalie_returned",
    // Corrections and the rest
    "strength_set", // value: home skaters * 10 + away skaters (e.g. 54 = home 5, away 4)
    "danger", // high-danger chance or scramble: pull quotes for a few seconds
    "scoring_chance", // side: a chance building for that team; pull the quotes a goal would run over until it resolves (toggle)
    "shootout_winner", // side (regular season only)
    // Attendance (PLAN.md §5.3): the operator steps away with the clock stopped; the risk layer keeps the quotes up, wider, until a tap, HOLD OFF, expiry or the feed
    "hold", // value: seconds the hold lasts (60–holdMaxSeconds)
    "hold_off",
    "undo",
];
const isHockeyEventKind = (v) => typeof v === "string" && exports.HOCKEY_EVENT_KINDS.includes(v);
exports.isHockeyEventKind = isHockeyEventKind;
/** Kinds that must name a team. */
exports.SIDED_HOCKEY_KINDS = new Set([
    "goal", "goal_pending", "penalty_minor", "penalty_double_minor", "penalty_major", "penalty_misconduct",
    "penalty_expired", "penalty_shot", "delayed_penalty", "goalie_pulled", "goalie_returned", "shootout_winner", "scoring_chance",
]);
/** Kinds that carry a number in `value`. */
exports.VALUED_HOCKEY_KINDS = new Set([
    "game_type", "clock_set", "clock_nudge", "strength_set", "hold",
]);
/** Clock and frame events are corrections of the record, not plays: UNDO skips them. */
exports.UNDOABLE_HOCKEY_KINDS = new Set([
    "goal", "goal_pending", "goal_confirmed", "goal_overturned",
    "penalty_minor", "penalty_double_minor", "penalty_major", "penalty_misconduct", "penalty_coincidental",
    "penalty_expired", "penalty_shot", "penalty_shot_miss", "delayed_penalty", "delayed_penalty_off",
    "goalie_pulled", "goalie_returned", "strength_set", "danger", "scoring_chance", "shootout_winner", "final", "period_end", "period_start",
]);
